// extracted by mini-css-extract-plugin
export default {"header-container":"header_header-container__OUadw","mode-switch":"header_mode-switch__Fim8u","darkMode":"header_darkMode__j-nUN"};